import {Context, useContext} from 'react';

export function useRequiredContext<T>(
  context: Context<T>,
  onUndefined: () => never = () => {
    throw new Error(
      `Context ${context.displayName || context} is required but was not set!`,
    );
  },
): NonNullable<T> {
  const value = useContext(context);
  if (value === undefined || value === null) {
    onUndefined();
  }
  return value;
}
